<router-outlet></router-outlet>
<app-ribbon [environment]="environment"></app-ribbon>
<app-toast-message-component class="toast-message"></app-toast-message-component>
